import { HeaderConfig } from '@/types/header-footer-config'

export function getHeaderShellClassName(
  sticky: boolean,
  showBorder: boolean,
  scroll: boolean | undefined,
  scrolled: boolean
) {
  const stickyClassName = sticky ? 'fixed sm:sticky' : 'relative'

  if (scroll) {
    if (scrolled) {
      return `top-0 z-40 flex w-full justify-center bg-background/60 backdrop-blur-xl border-b ${stickyClassName} ${
        showBorder ? 'border-b bg-background/95 shadow-sm supports-backdrop-blur:bg-background/60' : 'bg-background/95'
      }`
    }

    return `top-0 z-40 flex w-full justify-center bg-background/60 backdrop-blur-xl border-b ${stickyClassName} bg-background/0`
  }

  return `top-0 z-40 flex w-full justify-center bg-background/60 backdrop-blur-xl border-b ${stickyClassName} ${
    showBorder ? 'border-b bg-background/95 shadow-sm supports-backdrop-blur:bg-background/60' : 'bg-background/95'
  }`
}

export const headerContentWidthClassNames: Record<NonNullable<HeaderConfig['containerWidth']>, string> = {
  auto: '',
  sm: 'max-w-4xl mx-auto',
  md: 'max-w-5xl mx-auto',
  lg: 'max-w-6xl mx-auto',
  full: 'w-full',
}

/**
 * Returns header shell class for the general-v1-overlay preset.
 * Absolute positioning, transparent background, glass pill on scroll.
 */
export function getGeneralV1OverlayClassName(scrolled: boolean): string {
  const base = 'absolute top-0 left-0 right-0 z-40 flex w-full justify-center border-0'
  if (scrolled) {
    return `${base} bg-[var(--gv1-bg-primary)]/80 backdrop-blur-xl shadow-sm`
  }
  return `${base} bg-transparent`
}
